<template>
  <div>
    <AppNav></AppNav>
    <slot></slot>
  </div>
</template>

<script>
// import MobileSidebar from "./MobileSidebar";
// import Sidebar from "./Sidebar";
import AppNav from "./AppNav";

export default {
  // components: { MobileSidebar, Sidebar },
  components: { AppNav },
  props: ["actions", "videoTitle"],
};
</script>
